/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import '@gh/common-shared/polyfills';
import '@gh/common-shared/sentry';

import 'hammerjs';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import '@angular/compiler';
import '@gh/theme';

import { BuilderAppModule } from './builder-app.module';

import './index.css';

if (process.env.ANGULAR_PROD_MODE) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(BuilderAppModule);
